module.exports = __webpack_public_path__ + "bafab3f4f56de8301df2f78da522d9c9.svg";